import LayoutActividad from "../../../components/LayoutActividad";
import { modulo12 } from "../../../routes/Module12";
import Sidebar from "../Sidebar";
import Imagen21 from "../../../images/modulo12/20.png";
import Imagen22 from "../../../images/modulo12/21.png";
import Imagen23 from "../../../images/modulo12/22.png";
import GuiaDocente from "../../../components/GuiaDocente";

const Actividad1 = () => {
  const infoUnidad = modulo12.content[0];
  const infoAct = modulo12.content[0].activities[1];
  const crumbs = [
    {
      title: modulo12.title,
      url: "/" + modulo12.url,
    },
    {
      title:
        modulo12.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo12.content[0].name}: ${modulo12.content[0].activities[2].name}`,
    linkNext: `${modulo12.url}/${modulo12.content[0].path}/${modulo12.content[0].activities[2].path}`,
    titlePrev: `${modulo12.content[0].name}: ${modulo12.content[0].activities[0].name}`,
    linkPrev: `${modulo12.url}/${modulo12.content[0].path}/${modulo12.content[0].activities[0].path}`,
  };

  const metadata = {
    color: modulo12.color,
    title: `${modulo12.title} - ${infoAct.name}`,
    name: modulo12.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <div className="row mb-3">
        <div className="col-12">
          <h2 className="mb-5">{infoAct.name}</h2>

          <div className="bg-light mt-5 p-4 p-md-5">
            <h2>¿Somos diversos los peruanos?</h2>
            <div className="row mt-3 align-items-center">
              <div className="col-md-6 col-12 p-4">
                <p>
                  Los peruanos somos muy distintos. Algunos somos hombres, otras
                  mujeres. Hay niños y niñas, jóvenes y mayores. También nos
                  vemos distintos. Algunos somos como María Luisa, que ha
                  aprendido a usar su silla de ruedas para jugar básket.
                </p>
              </div>
              <div className="col-md-6 col-12 text-center">
                <img src={Imagen21} className="img-fluid" alt="Peruanos" />
              </div>

              <div className="col-md-6 col-12 text-center">
                <img src={Imagen22} className="img-fluid" alt="Peruanos" />
              </div>
              <div className="col-md-6 col-12 p-4 p-md-5">
                <p>
                  También hacemos cosas diferentes: unos estudiamos, otros
                  trabajamos. Lo que hacemos depende de nuestras posibilidades y
                  de lo que nos gusta.
                </p>
              </div>
              <div className="col-md-6 col-12 p-4 p-md-5">
                <p>
                  Siempre ha habido gente diversa en el Perú. Vivir juntos en el
                  mismo país siendo tan diferentes es un reto.
                </p>
              </div>
              <div className="col-md-6 col-12 text-center">
                <img src={Imagen23} className="img-fluid" alt="Peruanos" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>Lea el título del texto: ¿Somos diversos los peruanos?</li>
          <li>Pregunte qué significa la palabra “diversos”</li>
          <li>Lean el texto en voz alta.</li>
          <li>
            Resalte, retomando lo leído, que hay múltiples factores que nos
            distinguen, por ejemplo:
            <ul>
              <li>
                <i>
                  “Algunos somos hombres, otras mujeres. (…) niños, jóvenes,
                  mayores. Nos vemos distintos (…). Nos dedicamos a actividades
                  distintas: trabajar, estudiar, etc.”
                </i>
              </li>
            </ul>
          </li>
          <li>
            Retome los significados de la palabra “diversos” y confronte estos
            significados con lo que piensan después de leer el texto.
          </li>
          <li>
            Finalmente, señale que, en este contexto, la diversidad se refiere a
            lo que nos distingue como personas.
          </li>
          <li>
            Enfatice que la diversidad ha sido una característica a lo largo de
            toda nuestra historia y que ello lo trataremos en las siguientes
            actividades.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad1;
